import { config } from "@targeted-support/config";

const COMMON_SITUATION_OPTIONS = [
  "Future Investor",
  "Future Investor ISA",
  "Excess Savings",
  "Excess Savings Maxed Pension",
  "Irregular Investor",
  "High Risk but should be Low",
  "High Risk but should be Medium",
  "High Risk but should be Medium ISA",
  "Low Risk but should be High",
  "Low Risk but should be High ISA",
  "Inappropriate Investor",
] as const;

const LLOYDS_SITUATION_OPTIONS = [
  ...COMMON_SITUATION_OPTIONS,
  "Future Investor Club Lloyds",
  "Future Investor Club Lloyds ISA",
  "Family Member Lend a Hand Mortgage",
  "Inappropriate Investor Club Lloyds",
] as const;

export const SITUATION_OPTIONS = LLOYDS_SITUATION_OPTIONS;

export function getSituationOptionsForOrganisation(
  tenantId: string | undefined,
): readonly string[] {
  if (tenantId === config.LLOYDS_ORGANISATION_ID) return LLOYDS_SITUATION_OPTIONS;
  return COMMON_SITUATION_OPTIONS;
}

export const SEGMENT_OPTIONS = [
  "Disengaged Low Income",
  "Disengaged",
  "Open to Investing",
  "Supported Investing",
  "Self-Sufficient Investing",
  "Hyper-Engaged Investing",
] as const;

const LLOYDS_SUGGESTION_OPTIONS = [
  "Monthly Saver",
  "Easy Saver",
  "Cash ISA Saver",
  "Club Lloyds Advantage Saver",
  "Club Lloyds Monthly Saver",
  "Club Lloyds Advantage Saver ISA",
  "Fixed Rate Cash ISA",
  "Online Fixed Bonds",
  "Ready Made Pension",
  "Ready Made Investment",
  "Self Invested Personal Pension",
  "Share Dealing Account",
  "Ready Made Investment ISA",
  "Share Dealing ISA",
  "Lend a Hand Fixed Savings Account",
  "Club Lloyds Saver",
] as const;

const DEMO_SUGGESTION_OPTIONS = [
  "Regular Saver",
  "Instant Access Saver",
  "Cash ISA",
  "Fixed Rate Cash ISA",
  "Fixed Term Savings",
  "Managed Pension",
  "Managed Investment Account",
  "Self-Managed Pension",
  "Trading Account",
  "Managed Investment ISA",
  "Stocks and Shares ISA",
] as const;

const NATWEST_SUGGESTION_OPTIONS = [
  "Digital Regular Saver",
  "Flexible Saver",
  "Cash ISA",
  "Fixed Rate Cash ISA",
  "Fixed Term Savings",
  "NatWest Pension",
  "General Investment Account",
  "Junior ISA",
  "Stocks and Shares ISA",
] as const;

export const SUGGESTION_OPTIONS = LLOYDS_SUGGESTION_OPTIONS;

export function getSuggestionOptionsForOrganisation(
  tenantId: string | undefined,
): readonly string[] {
  if (tenantId === config.LLOYDS_ORGANISATION_ID) return LLOYDS_SUGGESTION_OPTIONS;
  if (tenantId === config.NATWEST_ORGANISATION_ID) return NATWEST_SUGGESTION_OPTIONS;
  return DEMO_SUGGESTION_OPTIONS;
}
